import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'punch-approvals'

const initialState = {
  list: null,
  loading: false,
  error: null,
}

export const search = createApiAction('leave/punch-request/search', client.search('/api/leave/punch-request'))
export const get = createApiAction('leave/punch-request/get', client.retrieve(`/api/leave/punch-request/:id`))
export const saveSelf = createApiAction('leave/punch-request/save', client.save('/api/leave/punch-request'))
export const saveStaff = createApiAction('leave/punch-request/saveStaff', client.save('/api/leave/punch-request/staff/:personId'))

const update = (state, action) => {
  const updatedItem = action.payload
  if (!state.list) {
    state.list = [updatedItem]
    return
  }
  if (state.list.some(item => item.id === updatedItem.id)) {
    state.list = state.list.map(item =>
      item.id === updatedItem.id ? { ...item, ...updatedItem } : item
    )
  } else {
    state.list = [...state.list, updatedItem]
  }
}


const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    removeItem: (state, action) => {
      state.list = state.list?.filter(item => item.id !== action.payload)
    },
    patchListItem: (state, action) => {
      const { id, ...patch } = action.payload
      if (state.list) {
        state.list = state.list.map(item =>
          item.id === id ? { ...item, ...patch } : item
        )
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
        state.loading = false
      })
      .addCase(get.fulfilled, update)
      .addCase(saveSelf.fulfilled, update)
      .addCase(saveStaff.fulfilled, update)
  },
})

export const { removeItem, patchListItem } = sessionSlice.actions;
export default sessionSlice.reducer
